export const formatToVttTime = (seconds) => {
  const ms = seconds * 1000 % 1000;
  const s = Math.floor(seconds % 60);
  const m = Math.floor(seconds / 60 % 60);
  const h = Math.floor(seconds / (60 * 60) % 24);
  const mss = `${ms}00`.slice(0, 3);
  const ss = `0${s}`.slice(-2);
  const mm = `0${m}`.slice(-2);
  const hh = `0${h}`.slice(-2);
  return `${hh}:${mm}:${`${ss}.${mss}`}`;
};

const createVttFromWords = (sentences) => {
  const webVttString = sentences.reduce((finalString, sentence) => {
    const fromTime = formatToVttTime(Number(sentence.startTime) /1000);
    const toTime = formatToVttTime(Number(sentence.endTime) /1000);
    return `${finalString}${fromTime} --> ${toTime}\n${sentence.text}\n\n`;
  }, 'WEBVTT\n\n');
  return URL.createObjectURL(new Blob([webVttString], {type: 'text/vtt'}));
};

export function generateVttFromStt(utterances) {
  const cues = Object.values(utterances)
  const result = createVttFromWords(cues)
  return result
}
